export { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "./component";
